import en from './en/translation.json';

export const config = {
  defaultNS: 'translation',
  resources: {
    en: en,
  },
  lng: 'en',
  fallbackLng: 'en',
};
